module.exports = __webpack_public_path__ + "static/img/restaurant-filter-icon03.dbbe1019.svg";